import { render, staticRenderFns } from "./editProvider.vue?vue&type=template&id=3f7ee836&lang=pug&"
import script from "./editProvider.vue?vue&type=script&lang=js&"
export * from "./editProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports